/* Keuzehulp My Dental Products
 * Antwoorden worden op volgorde (index) gelezen, zodat teksten in de theme editor mogen veranderen.
 *  Vraag 1 (doel):      0 Witte tanden | 1 Gezond tandvlees | 2 Frisse adem | 3 Gevoelige tanden
 *  Vraag 2 (gevoelig):  0 Vaak | 1 Soms | 2 Niet
 *  Vraag 3 (beugel):    0 Ja | 1 Nee
 *  Vraag 4 (nu):        0 Niets | 1 Floss of ragers | 2 Waterflosser
 * Regels zijn identiek aan de controle-pagina "Keuzehulp Uitkomsten MDP".
 */
(function () {
  if (window.__tbcKeuzehulp) return;
  window.__tbcKeuzehulp = true;

  var HANDLES = {
    pap: 'my-whitestrips-pap-coconut-charcoal',
    bundel: 'waterflosser-en-whitestrips',
    wf: 'my-waterflosser',
    hbundel: 'slechte-adem-voordeelpakket-halita',
    wtp: 'my-whitening-tandpasta-80ml',
    senso: 'sensodyne-repair-protect-whitening-tandpasta-75-ml',
    gtmw: 'vitis-gezond-tandvlees-mondspoelmiddel-500-ml',
    tong: 'my-tongschraper',
    hmw: 'halita-slechte-adem-mondspoelmiddel-500-ml',
    hspray: 'mouth-spray-fresh-breath-halita'
  };
  var DOEL = ['wit', 'tandvlees', 'adem', 'gevoelig'];
  var GEV = ['vaak', 'soms', 'niet'];
  var BEUGEL = ['ja', 'nee'];
  var NU = ['niets', 'floss', 'wf'];

  function build(a) {
    var heeftWF = a.nu === 'wf';
    var wilWF = !heeftWF && (a.doel === 'tandvlees' || a.beugel === 'ja' || (a.nu === 'niets' && a.doel !== 'gevoelig'));
    var items = []; // [key, stap-tekst, prioriteit]
    var why = [];
    var papSchema = { vaak: '2× per week, 30 minuten', soms: '3× per week, 30 minuten', niet: 'Dagelijks 30 minuten, 14 dagen' }[a.gev];
    var papItem = wilWF
      ? ['bundel', 'Strips: ' + papSchema.toLowerCase() + '. Waterflosser: dagelijks, avond', 1]
      : ['pap', papSchema, 1];

    if (a.doel === 'wit') {
      items.push(papItem);
      items.push(a.gev === 'vaak' ? ['senso', 'Dagelijks, ochtend en avond', 3] : ['wtp', 'Dagelijks, ochtend en avond', 3]);
      why.push({
        vaak: 'PAP+ is peroxidevrij en we combineren het met een tandpasta voor gevoelige tanden.',
        soms: 'PAP+ is peroxidevrij, dus ook prima als je tanden soms gevoelig zijn.',
        niet: 'Geen gevoeligheid, dus je kunt de kuur in 14 dagen afronden.'
      }[a.gev]);
    }
    if (a.doel === 'tandvlees') {
      if (wilWF) items.push(['wf', 'Dagelijks, avond, 1 minuut', 1]);
      items.push(['gtmw', 'Dagelijks na het poetsen', 2]);
      if (a.gev === 'vaak') items.push(['senso', 'Dagelijks, ochtend en avond', 4]);
      why.push('Bloedend of gevoelig tandvlees begint tussen je tanden, daar richt deze routine zich op.');
    }
    if (a.doel === 'adem') {
      items.push(['hbundel', 'Mondwater, tandpasta, tongschraper en spray. Ochtend en avond', 1]);
      items.push(wilWF ? ['wf', 'Dagelijks, avond', 2] : ['wtp', 'Dagelijks, ochtend en avond', 2]);
      why.push('Slechte adem komt meestal van je tong en etensresten tussen je tanden. Je pakt nu allebei aan.');
    }
    if (a.doel === 'gevoelig') {
      papItem[1] = wilWF ? papItem[1] : (a.gev === 'niet' ? '3× per week, 30 minuten' : '2× per week, 30 minuten');
      items.push(papItem);
      items.push(['senso', 'Dagelijks, ochtend en avond', 2]);
      items.push(['gtmw', 'Dagelijks na het poetsen', 3]);
      why.push('Wittere tanden zonder pijn: PAP+ werkt zonder waterstofperoxide, de grootste oorzaak van gevoeligheid bij whitening.');
      why.push(a.gev === 'niet'
        ? 'Je tanden zijn nu niet gevoelig. Sensodyne helpt dat zo te houden tijdens de kuur.'
        : 'Sensodyne beschermt je tanden tijdens de kuur, en je bouwt rustig op.');
    }
    if (a.beugel === 'ja') {
      why.push(heeftWF
        ? 'Gebruik je waterflosser ook rond je beugel of implantaat, daar komt floss niet bij.'
        : 'De waterflosser komt rond je beugel of implantaat, waar floss niet bij kan.');
    }
    if (a.nu === 'niets') why.push(wilWF ? 'Je doet nu nog niets naast poetsen. Dit is je complete basis.' : 'Je begint klein. Makkelijk vol te houden.');
    if (a.nu === 'floss') why.push(wilWF ? 'Je flost al. De waterflosser komt op plekken waar floss niet goed bij kan.' : 'Je flost al, dus we vullen alleen aan wat ontbreekt.');
    if (heeftWF) why.push('Je hebt al een waterflosser, dus die zit er niet in.');
    if (a.gev === 'vaak' && (a.doel === 'tandvlees' || a.doel === 'adem') && (wilWF || heeftWF)) why.push('Begin op de laagste stand en bouw rustig op, want je tanden zijn vaak gevoelig.');

    items.sort(function (x, y) { return x[2] - y[2]; });
    var titles = {
      wit: 'Jouw routine voor wittere tanden',
      tandvlees: 'Jouw routine voor gezond tandvlees',
      adem: 'Jouw routine voor frisse adem',
      gevoelig: 'Wittere tanden, zonder gevoeligheid'
    };
    return { title: titles[a.doel], items: items.slice(0, 3), why: why };
  }
  window.TbcKeuzehulpBuild = build;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {};
  function getProduct(key) {
    if (!cache[key]) {
      cache[key] = fetch(root + 'products/' + HANDLES[key] + '.js')
        .then(function (r) { if (!r.ok) throw new Error(key); return r.json(); })
        .then(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
          var img = (v.featured_image && v.featured_image.src) || p.featured_image || '';
          return { key: key, title: p.title, url: root + 'products/' + p.handle, id: v.id, price: v.price, compare: v.compare_at_price, available: !!v.available, image: img };
        })
        .catch(function () { return null; });
    }
    return cache[key];
  }
  function money(cents) {
    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }
  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function sized(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function init(el) {
    if (el.dataset.quizReady) return;
    el.dataset.quizReady = '1';
    var start = el.querySelector('[data-quiz-start]');
    var qScreen = el.querySelector('[data-quiz-question-screen]');
    var result = el.querySelector('[data-quiz-result]');
    var questions = [];
    try { questions = JSON.parse(el.querySelector('[data-quiz-questions]').textContent); } catch (e) { return; }

    var step = 1;
    var idx = {};    // vraagnummer -> gekozen index
    var labels = {}; // vraagnummer -> gekozen tekst
    var current = [];
    var discountPct = Number(el.dataset.discountPercent || 0);
    var code = el.dataset.discountCode || '';

    function show(which) {
      start.hidden = which !== 'start';
      qScreen.hidden = which !== 'q';
      result.hidden = which !== 'result';
    }

    function renderQuestion() {
      show('q');
      var q = questions[step - 2];
      if (!q) return;
      el.querySelector('[data-quiz-question-title]').textContent = q.title;
      el.querySelector('[data-quiz-step]').textContent = step + ' van 4';
      var bar = el.querySelector('[data-quiz-progress]');
      bar.setAttribute('aria-valuenow', step);
      bar.querySelector('span').style.width = (step * 25) + '%';
      var box = el.querySelector('[data-quiz-options]');
      box.innerHTML = q.options.map(function (o, i) {
        return '<button type="button" class="tbc-collection-page__quiz-option" data-quiz-answer data-question="' + step + '" data-index="' + i + '" data-label="' + esc(o) + '">' +
          '<span class="tbc-collection-page__quiz-option-text">' + esc(o) + '</span>' +
          '<span class="tbc-collection-page__quiz-option-arrow"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3.33 8h9.34M8 3.33 12.67 8 8 12.67" stroke="#141414" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg></span></button>';
      }).join('');
    }

    function answersObj() {
      return {
        doel: DOEL[idx[1]] || 'wit',
        gev: GEV[idx[2]] || 'soms',
        beugel: BEUGEL[idx[3]] || 'nee',
        nu: NU[idx[4]] || 'floss'
      };
    }

    function renderResult() {
      show('result');
      var r = build(answersObj());
      el.querySelector('[data-quiz-result-title]').textContent = r.title;
      el.querySelector('[data-quiz-why]').innerHTML = r.why.map(function (w) {
        return '<li><span aria-hidden="true">✓</span> ' + esc(w) + '</li>';
      }).join('');
      var box = el.querySelector('[data-quiz-products]');
      box.innerHTML = '<p class="tbc-collection-page__quiz-message">Je routine wordt samengesteld…</p>';
      el.querySelector('[data-quiz-original-total]').textContent = '';
      el.querySelector('[data-quiz-discount-total]').textContent = '';
      var token = {};
      renderResult.token = token;

      Promise.all(r.items.map(function (it) { return getProduct(it[0]); })).then(function (prods) {
        if (renderResult.token !== token) return;
        current = [];
        var n = 0;
        box.innerHTML = prods.map(function (p, i) {
          if (!p || !p.available) return '';
          n += 1;
          current.push(p);
          return '<article class="tbc-collection-page__quiz-product">' +
            '<a class="tbc-collection-page__quiz-product-image" href="' + p.url + '">' + (p.image ? '<img src="' + esc(sized(p.image, 180)) + '" alt="' + esc(p.title) + '" loading="lazy" width="90" height="90">' : '') + '</a>' +
            '<div class="tbc-collection-page__quiz-product-info">' +
              '<span class="tbc-collection-page__quiz-product-step">Stap ' + n + '</span>' +
              '<a class="tbc-collection-page__quiz-product-title" href="' + p.url + '">' + esc(p.title) + '</a>' +
              '<span class="tbc-collection-page__quiz-product-subtitle">' + esc(r.items[i][1]) + '</span>' +
            '</div>' +
            '<strong class="tbc-collection-page__quiz-product-price">' + money(p.price) + '</strong>' +
          '</article>';
        }).join('');
        var total = current.reduce(function (s, p) { return s + p.price; }, 0);
        var anchor = current.reduce(function (s, p) { return s + (p.compare && p.compare > p.price ? p.compare : p.price); }, 0);
        var discounted = Math.round(total * (100 - discountPct) / 100);
        el.querySelector('[data-quiz-original-total]').textContent = money(anchor);
        el.querySelector('[data-quiz-discount-total]').textContent = money(discounted);
        el.querySelector('[data-quiz-add]').disabled = current.length === 0;
        if (!current.length) box.innerHTML = '<p class="tbc-collection-page__quiz-message">Deze routine is tijdelijk uitverkocht. Bekijk de producten los.</p>';
      });
    }

    function addRoutine(btn) {
      var msg = el.querySelector('[data-quiz-message]');
      if (!current.length) return;
      btn.disabled = true;
      var label = btn.textContent;
      btn.textContent = 'Toevoegen…';
      msg.textContent = '';
      var a = answersObj();
      var summary = [labels[1], labels[2], labels[3], labels[4]].filter(Boolean).join(' / ');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: current.map(function (p) { return { id: p.id, quantity: 1, properties: { _keuzehulp: a.doel } }; }) })
      })
        .then(function (res) { if (!res.ok) throw new Error('add'); return res.json(); })
        .then(function () {
          return fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { 'Keuzehulp': summary, 'Keuzehulp uitkomst': [a.doel, a.gev, a.beugel, a.nu].join('|') } })
          }).catch(function () {});
        })
        .then(function () {
          if (window.dataLayer) window.dataLayer.push({ event: 'keuzehulp_add', keuzehulp_uitkomst: [a.doel, a.gev, a.beugel, a.nu].join('|') });
          var dest = root + 'cart';
          window.location.href = code ? root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest) : dest;
        })
        .catch(function () {
          msg.textContent = 'Toevoegen is niet gelukt. Probeer het opnieuw.';
          btn.disabled = false;
          btn.textContent = label;
        });
    }

    el.addEventListener('click', function (e) {
      var ans = e.target.closest('[data-quiz-answer]');
      if (ans && el.contains(ans)) {
        var qn = Number(ans.dataset.question);
        idx[qn] = Number(ans.dataset.index);
        labels[qn] = ans.dataset.label;
        if (step < 4) { step += 1; renderQuestion(); }
        else renderResult();
        return;
      }
      if (e.target.closest('[data-quiz-back]')) {
        if (step > 2) { step -= 1; renderQuestion(); } else { step = 1; show('start'); }
        return;
      }
      if (e.target.closest('[data-quiz-restart]')) {
        step = 1; idx = {}; labels = {}; current = [];
        show('start');
        return;
      }
      var add = e.target.closest('[data-quiz-add]');
      if (add) addRoutine(add);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-keuzehulp-v2]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  // Grid wordt bij filteren/laden opnieuw opgebouwd
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; initAll(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
